import { graphql } from 'gatsby';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage';
import Video from '@/components/Video/Video';
import { Container, Wrapper } from './SingleMedia.styles';
import { applyPaddingCSS } from '@/utils/generatePadding';
import { type BlockHTMLId } from '@/utils/renderBlock';

const SingleMedia = ({
  singleMediaElements: elements,
  system,
  id,
}: Queries.SINGLE_MEDIAFragment & BlockHTMLId) => {
  const type = elements.media.value.__typename;
  const hasBackground = elements.options?.value?.includes('has_background') ?? false;

  return (
    <Container css={applyPaddingCSS(elements)} data-codename={system.codename} id={id}>
      <Wrapper columns={elements.width.value} hasBackground={hasBackground}>
        {type === 'kontent_item_responsive_image' && <ResponsiveImage {...elements.media.value} />}
        {type === 'kontent_item_video' && <Video {...elements.media.value} />}
      </Wrapper>
    </Container>
  );
};

export const fragment = graphql`
  fragment SINGLE_MEDIA on kontent_item_single_media {
    __typename
    singleMediaElements: elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      ...PADDING
      media {
        value {
          __typename
          ...VIDEO
          ...RESPONSIVE_IMAGE
        }
      }
      width {
        value
      }
      options {
        value
      }
    }
    system {
      codename
      id
    }
  }
`;

export default SingleMedia;
